if ( document.body.classList.contains('home') ) {
    const elem = document.querySelector("#main .entry-content");
	if (elem.childNodes.length <= 1) {
		document.querySelector("#content .suki-content-inner").style.padding = 0;
	}
}

if ( document.body.classList.contains('blog') ) {
    const loopElem = document.querySelector('#loop.suki-loop-grid.suki-loop-grid-3-columns');
    if (loopElem) {
        loopElem.classList.add('suki-loop-grid-2-columns');
        loopElem.classList.remove('suki-loop-grid-3-columns');
    }
}

import './aptumistic/slide';
